// extracted by mini-css-extract-plugin
export default {"list":"CheckboxGroup_list__2T8OC","item":"CheckboxGroup_item__3Lwt_"};